import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep, NumericDictionary } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import MultiPolygon from 'ol/geom/MultiPolygon';
import Point from 'ol/geom/Point';
import Polygon from 'ol/geom/Polygon';
import { Circle, Fill, RegularShape, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import { Layer } from 'src/app/menu/view-menu/layer';
import { ShapeType } from 'src/app/models/EnumTypes';
import { UserLayer } from 'src/app/models/UserSettings';
import { PointsService } from 'src/app/services/points.service';
import { UserAddedLayersService } from 'src/app/services/userAddedLayers-management.service';
import { UserSettingsService } from 'src/app/services/userSettings.service';
import { FlagsTableElem } from '../configure-flight-inpection-format/configure-flight-inpection-format.component';

@Component({
  selector: 'app-style-editor',
  templateUrl: './style-editor.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class StyleEditorComponent implements OnInit {

  @Input() userLayer: UserLayer = new UserLayer(null,null,null,null,[]) ;
  @Input() layer: Layer;
  @Input() defaultLayer: UserLayer;
  @Input() fillCheckDisabled: boolean;
  @Input() staticLayer:boolean;
  @Input() markerCheckDisabled: boolean;
  constructor(public bsModalRef : BsModalRef,
    public userSettingsService: UserSettingsService,
    public pointsService: PointsService,
    public userAddedLayersService: UserAddedLayersService
    ) { }

  ngOnInit(): void {
  }
  apply(changeToDefault:boolean = false){
    if(changeToDefault){
      this.userLayer = cloneDeep(this.defaultLayer)
    }
    this.userAddedLayersService.applyLayerChange(this.userLayer,this.layer,this.staticLayer);
  }


  static showStyleEditor(popupService: BsModalService,layer:Layer, userLayer:UserLayer,staticLayer?:boolean){
    const bsRef: BsModalRef = popupService.show(StyleEditorComponent);
    if(staticLayer == null){
      userLayer.userLayerColorActive = true;
    }
    bsRef.content.staticLayer = staticLayer != null;
    bsRef.content.userLayer = cloneDeep(userLayer);
    bsRef.content.layer = layer;

    bsRef.content.fillCheckDisabled = false;
    bsRef.content.markerCheckDisabled = true;
    if(layer.olLayer.getSource().getFeatures()[0].get('geometry') instanceof LineString || layer.olLayer.getSource().getFeatures()[0].get('geometry') instanceof MultiLineString){

      bsRef.content.userLayer.fillChecked = false;
      bsRef.content.fillCheckDisabled = true;

    }
    else if(layer.olLayer.getSource().getFeatures()[0].get('geometry') instanceof Point){
      bsRef.content.markerCheckDisabled = false;
      bsRef.content.userLayer.markerChecked = true;
    }
    bsRef.content.defaultLayer = cloneDeep(userLayer);
  }
}
